import { lazy } from "react";

export const RoutePaths = [
  {
    path: "/login",
    component: lazy(() => import("../pages/Login")),
    meta: {
      authRoute: false,
      roles: ["admin", "subadmin"],
    },
  },
  // Dashboard
  {
    path: "/",
    component: lazy(() => import("../pages/DashboardOverview")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // Surname
  {
    path: "/users",
    component: lazy(() => import("../pages/Users/Users")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  {
    path: "/members",
    component: lazy(() => import("../pages/Users/Filteruser.jsx")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // Surname-Form
  {
    path: "/users-form",
    component: lazy(() => import("../pages/Users/UsersForm")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // Memebers-Form
  {
    path: "/member-form",
    component: lazy(() => import("../pages/Users/MemberForm")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },

  // Category
  {
    path: "/category",
    component: lazy(() => import("../pages/Category/Category")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // Category-Form
  {
    path: "/category-form",
    component: lazy(() => import("../pages/Category/CategoryForm")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // Category-Data
  {
    path: "/category-data",
    component: lazy(() => import("../pages/CategoryData/CategoryData")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // Category-Data-Form
  {
    path: "/category-data-form",
    component: lazy(() =>
      import("../pages/CategoryData/CategoryCategoryDataForm")
    ),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // Blood-Group
  {
    path: "/bloodGroup",
    component: lazy(() => import("../pages/BloodGroup/BloodGroup")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // Blood-Group-Form
  {
    path: "/bloodGroup-form",
    component: lazy(() => import("../pages/BloodGroup/BloodGroupForm")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // PhotoGallary
  {
    path: "/photo-gallery",
    component: lazy(() => import("../pages/PhotoGallary/PhotoGallary")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // PhotoGallary-Form
  {
    path: "/photo-gallery-form",
    component: lazy(() => import("../pages/PhotoGallary/PhotoGallaryForm")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // PhotoGallary
  {
    path: "/gallery-category",
    component: lazy(() =>
      import("../pages/PhotoGallaryCategory/PhotoGallaryCategory")
    ),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // PhotoGallary-Form
  {
    path: "/gallery-category-form",
    component: lazy(() =>
      import("../pages/PhotoGallaryCategory/PhotoGallaryCategoryForm")
    ),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // Video
  {
    path: "/video",
    component: lazy(() => import("../pages/Video/Video")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // Video-Form
  {
    path: "/video-form",
    component: lazy(() => import("../pages/Video/VideoForm")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // Video
  {
    path: "/video-category",
    component: lazy(() => import("../pages/VideoCategory/VideoCategory")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // Video-Form
  {
    path: "/videoCategory-form",
    component: lazy(() => import("../pages/VideoCategory/VideoCategoryForm")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  {
    path: "/contact-us",
    component: lazy(() => import("../pages/Contact_Us/ContactUsPage")),
    meta: {
      authRoute: false,
      roles: ["admin", "subadmin"],
    },
  },
  {
    path: "/privacy-policy",
    component: lazy(() => import("../pages/Privacy_Policy/PrivacyPolicy")),
    meta: {
      authRoute: false,
      roles: ["admin", "subadmin"],
    },
  },
  {
    path: "/notification",
    component: lazy(() => import("../pages/Notification/Notification")),
    meta: {
      authRoute: false,
      roles: ["admin", "subadmin"],
    },
  },
  {
    path: "/notification-form",
    component: lazy(() => import("../pages/Notification/NotificationForm")),
    meta: {
      authRoute: false,
      roles: ["admin", "subadmin"],
    },
  },
  {
    path: "/community",
    component: lazy(() =>
      import("../pages/CommunityCategory/CommunityCategory")
    ),
    meta: {
      authRoute: false,
      roles: ["admin", "subadmin"],
    },
  },
  {
    path: "/commity-category",
    component: lazy(() =>
      import("../pages/CommunityCategory/CommunityCategoryForm")
    ),
    meta: {
      authRoute: false,
      roles: ["admin", "subadmin"],
    },
  },
  {
    path: "/commity-member",
    component: lazy(() => import("../pages/CommunityMember/CommunityMember")),
    meta: {
      authRoute: false,
      roles: ["admin", "subadmin"],
    },
  },
  {
    path: "/commity-member-form",
    component: lazy(() =>
      import("../pages/CommunityMember/CommunityMemberForm")
    ),
    meta: {
      authRoute: false,
      roles: ["admin", "subadmin"],
    },
  },
  {
    path: "/donor-category",
    component: lazy(() => import("../pages/Donor/Donor")),
    meta: {
      authRoute: false,
      roles: ["admin", "subadmin"],
    },
  },
  {
    path: "/donor-form",
    component: lazy(() => import("../pages/Donor/DonorForm")),
    meta: {
      authRoute: false,
      roles: ["admin", "subadmin"],
    },
  },
  {
    path: "/donor-member",
    component: lazy(() => import("../pages/DonorMember/DonorMember")),
    meta: {
      authRoute: false,
      roles: ["admin", "subadmin"],
    },
  },
  {
    path: "/donor-member-form",
    component: lazy(() => import("../pages/DonorMember/DonorMemberForm")),
    meta: {
      authRoute: false,
      roles: ["admin", "subadmin"],
    },
  },
  {
    path: "/customer-request",
    component: lazy(() => import("../pages/CustomerRequest/CustomerRequest")),
    meta: {
      authRoute: false,
      roles: ["admin", "subadmin"],
    },
  },
  {
    path: "/advertisement",
    component: lazy(() => import("../pages/Addvertisement/Addvertise")),
    meta: {
      authRoute: false,
      roles: ["admin", "subadmin"],
    },
  },
  {
    path: "/advertisement-form",
    component: lazy(() => import("../pages/Addvertisement/AddvertiseForm")),
    meta: {
      authRoute: false,
      roles: ["admin", "subadmin"],
    },
  },
  {
    path: "/result-category",
    component: lazy(() => import("../pages/ResultCategory/ResultCategory")),
    meta: {
      authRoute: false,
      roles: ["admin", "subadmin"],
    },
  },
  {
    path: "/resultCategory-form",
    component: lazy(() => import("../pages/ResultCategory/ResultCategoryForm")),
    meta: {
      authRoute: false,
      roles: ["admin", "subadmin"],
    },
  },
  {
    path: "/results",
    component: lazy(() => import("../pages/Result/Results")),
    meta: {
      authRoute: false,
      roles: ["admin", "subadmin"],
    },
  },
  {
    path: "/results-form",
    component: lazy(() => import("../pages/Result/ResultsForm")),
    meta: {
      authRoute: false,
      roles: ["admin", "subadmin"],
    },
  },
  {
    path: "/new-registration",
    component: lazy(() => import("../pages/UsersRequest/Users.jsx")),
    meta: {
      authRoute: false,
      roles: ["admin", "subadmin"],
    },
  },
  {
    path: "/new-registration-form",
    component: lazy(() => import("../pages/UsersRequest/UsersForm.jsx")),
    meta: {
      authRoute: false,
      roles: ["admin", "subadmin"],
    },
  },
  {
    path: "/user-registration-link",
    component: lazy(() =>
      import("../pages/RegestrationLink/RegestrationLink.jsx")
    ),
    meta: {
      authRoute: false,
      roles: ["admin", "subadmin"],
    },
  },
  {
    path: "/online-users",
    component: lazy(() => import("../pages/Users/OnlineUsers")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
];
